export default {
  computed: {
    navItems() {
      return this.generateNavItems()
    },
  },
  methods: {
    generateNavItems() {
      return [
        {
          key: 'nav-home',
          title: 'Home',
          icon: 'mdi-home-outline',
          to: '/',
        },
        {
          key: 'nav-messages',
          title: 'Messages',
          icon: 'mdi-forum-outline',
          to: '/message',
        },
        {
          key: 'nav-guarantees',
          title: 'Guarantees',
          icon: 'mdi-account-star-outline',
          to: '/candidate/guarantees',
          preview: true,
        },
        {
          key: 'nav-location-restrictions',
          title: 'Location Restrictions',
          icon: 'mdi-block-helper',
          to: '/location/restrictions',
        },
        {
          key: 'nav-booking-disputes',
          title: 'Booking Disputes',
          icon: 'mdi-sword-cross',
          to: '/bookings/disputes/v2',
        },
        {
          key: 'nav-release-notes',
          title: 'Releases',
          icon: 'mdi-rocket-launch',
          to: '/releases',
        },
      ]
    },

    isActiveNavItem(to) {
      return to === this.$route.path
    },
  },
}
